<div class="home">
    <div class="row mb-2 mb-md-4">
        <div class="col-12 filter d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
            <div class="wallet-overview">
                <h3 class="filter-text-primary mb-2 mb-md-0 me-4">Wallet Overview</h3>
                <div class="currency-filter">
                    <button [disabled]="isLoading" (click)="openChangeWalletModal()" class="wallet-select w-100">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center justify-content-between">
                                <img
                                    [src]="'../../../../../assets/currency-flags/' + selectedWallet.currency + '-flag.svg'"
                                    class="selected-currency-img"
                                    alt="currency-flag"
                                />
                                <span class="ms-2">{{ selectedWallet.currency }}</span>
                            </div>
                            <mat-icon>keyboard_arrow_down</mat-icon>
                        </div>
                    </button>
                </div>
            </div>

            <div class="month-filter">
                <div class="w-100">
                    <app-value-field [editMode]="true">
                        <app-value-field-select
                            *ngIf="walletForm.controls.duration"
                            [controlDisplayName]="'Transactions Duration'"
                            [control]="walletForm.controls.duration"
                            appValueField="editField"
                            placeholder="Select duration"
                        >
                            <ng-template *ngFor="let duration of durations" [appValueFieldOption]="duration.key">
                                <span>{{ duration.value }}</span>
                            </ng-template>
                        </app-value-field-select>
                    </app-value-field>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-8 col-12 ps-0 pe-0 pe-lg-4">
            <div class="d-flex flex-wrap justify-content-around gap-3">
                <div class="avb-balance mb-2 mb-lg-0 d-flex flex-column align-items-between justify-content-around" style="flex: 1">
                    <div class="d-flex justify-content-start align-items-center">
                        <div>
                            <mat-icon svgIcon="wallet"></mat-icon>
                        </div>
                    </div>

                    <div class="d-flex flex-wrap gap-3 justify-content-between align-items-center">
                        <div>
                            <p class="avb-balance-text-primary">{{ selectedWallet.balance | currency : selectedWallet.currency : '' }}</p>
                            <span class="avb-balance-text-secondary">Available Balance in {{ selectedWallet.currency }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="transactions mt-4">
                <p class="transactions-text-primary m-3">Transactions ({{ walletForm.controls['duration'].value | titlecase }})</p>
                <div class="lineChart">
                    <app-spinner [isLoading]="transactionGraphLoading" />
                    <canvas *ngIf="!transactionGraphLoading" baseChart [data]="lineChartData" [options]="lineChartOptions" [type]="lineChartType"></canvas>
                </div>
            </div>
        </div>

        <div class="col-lg-4 transactions">
            <p class="transactions-text-primary my-3">Recent Transactions</p>
            <div class="today-section">
                <span class="transactions-text-secondary me-2">TODAY</span>
                <div class="today-line"></div>
            </div>
            <app-spinner [isLoading]="transactionLoading" />
            <div *ngFor="let transaction of transactions">
                <div class="transaction-container py-4">
                    <div class="transaction-details">
                        <h6 class="transaction-header mb-0">
                            {{ transaction.receiver_name ? (transaction.receiver_name | titlecase) : (transaction.transaction_description | snakeCase) }}
                        </h6>
                        <p class="transaction-subheader mb-0">
                            {{ transaction.transaction_type | snakeCase | titlecase }} • {{ transaction.transaction_timestamp | date : 'dd MMM yyyy' }}
                        </p>
                    </div>

                    <div class="ps-1">
                        <p
                            class="transaction-amount"
                            [ngClass]="{
                                'text-red': isSent(transaction.transaction_type),
                                'text-green': !isSent(transaction.transaction_type)
                            }"
                        >
                            {{ isSent(transaction.transaction_type) ? '-' : '+' }}
                            {{ transaction.transaction_amount | currency : transaction.transaction_currency : '' }}
                            {{ transaction.transaction_currency }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
